export type TransactionTypeOption = 'SEND_TOKENS' | 'CONTRACT_INTERACTION' | 'TOKEN_ASSOCIATE';

export interface SendTokensData {
  address: string;
  amount: string;
  description: string;
  selectedToken: 'HBAR' | string;
  tokenDecimals: number;
  tokenSymbol: string;
}

export interface ContractInteractionData {
  contractId: string;
  abi: string;
  selectedMethod: string;
  methodInputs: Array<{
    name: string;
    type: string;
    value: any;
  }>;
  gas: string;
  payableAmount: string;
  description: string;
}

export interface TokenAssociationData {
  tokenId: string;
  tokenName: string;
  tokenSymbol: string;
  description: string;
}

export interface TransactionOptions {
  expirationTime: Date | null;
  waitForExpiry: boolean;
}

export interface WizardState {
  step: number;
  type: TransactionTypeOption | null;
  sendTokensData: SendTokensData;
  contractData: ContractInteractionData;
  tokenAssociationData: TokenAssociationData;
  options: TransactionOptions;
}

export const initialSendTokensData: SendTokensData = {
  address: '',
  amount: '',
  description: '',
  selectedToken: 'HBAR',
  tokenDecimals: 8,
  tokenSymbol: 'HBAR',
};

export const initialContractData: ContractInteractionData = {
  contractId: '',
  abi: '',
  selectedMethod: '',
  methodInputs: [],
  gas: '100000',
  payableAmount: '0',
  description: '',
};

export const initialTokenAssociationData: TokenAssociationData = {
  tokenId: '',
  tokenName: '',
  tokenSymbol: '',
  description: '',
};

export const initialOptions: TransactionOptions = {
  expirationTime: null,
  waitForExpiry: false,
};

export const initialWizardState: WizardState = {
  step: 1,
  type: null,
  sendTokensData: initialSendTokensData,
  contractData: initialContractData,
  tokenAssociationData: initialTokenAssociationData,
  options: initialOptions,
};
